;import { BasePlot } from './base_plot'
import { select } from 'd3-selection'

export abstract class ScrollingCanvasPlot extends BasePlot {

  protected ctx: CanvasRenderingContext2D;
  protected canvas;
  protected canvasD3;
  protected svg;
  protected margin = {top: 15, right: 20, bottom: 22, left: 60};
  private newDataBuffer: Array<Array<number>>

  public constructor(key: string, container: HTMLElement, width: number, height: number) {
      super(key, container, width, height);
      this.makeCanvas();
      this.newDataBuffer = [];
  }

  private makeCanvas() {
    let containerSel = select(this.container);
    this.screenWidth = this.container.clientWidth - this.margin.left - this.margin.right;
    this.screenHeight = this.container.clientHeight - this.margin.top - this.margin.bottom;
    this.width = this.screenWidth;
    this.height = this.screenHeight;

    this.canvasD3 = containerSel
        .append('canvas')
        .style('position', 'absolute')
        .style('margin-left', this.margin.left + 'px')
        .style('margin-top', this.margin.top + 'px')
        .style('width', (this.screenWidth) + 'px')
        .style('height', this.screenHeight + 'px')
        .style('z-index', -1)
        .attr('width', this.width)
        .attr('height', this.height);
    this.canvas = this.canvasD3.node();

    this.svg = select(this.container)
        .append("svg")
        .attr("width",this.screenWidth+this.margin.left+this.margin.right)
        .attr("height", this.screenHeight+this.margin.top+this.margin.bottom)
        .append("g")
          .attr("transform",
                "translate(" + this.margin.left + "," + this.margin.top + ")");

    this.ctx = this.canvas.getContext('2d');
    this.ctx.imageSmoothingEnabled = false;
    // console.log(this.ctx.getContextAttributes());
  }

  private shiftCanvasLeft(pixels: number){
    this.ctx.globalCompositeOperation = "copy";
    this.ctx.drawImage(this.ctx.canvas, -pixels, 0);
    this.ctx.globalCompositeOperation = "source-over";
  }

  protected abstract drawNewColumns(data: Array<Array<number>>): void;


  public update(data: Array<Array<number>>): void
  {
    this.newDataBuffer = this.newDataBuffer.concat(data);
  }

  public render(): void
  {
    if (this.newDataBuffer.length > 0)
    {
      this.shiftCanvasLeft(this.newDataBuffer.length);
      this.drawNewColumns(this.newDataBuffer);
      this.newDataBuffer = [];
    }
  }
}
